import MwcVueHelperMixin, { MwcConfigMixin } from "mwc-vue-component-helper";
import { DataProviderHelperMixin } from "./MwcTokenSourceMixin";
import MwcLocalesMixin from "./MwcLocalesMixin";

export default {
    name: "mwc-shared-mixin",
    mixins: [MwcVueHelperMixin, MwcConfigMixin, DataProviderHelperMixin, MwcLocalesMixin]
};
